import { Component } from '@angular/core';

@Component({
    selector: 'app-dashboard-table-skeleton',
    templateUrl: './dashboard-table-skeleton.component.html',
    styleUrl: './dashboard-table-skeleton.component.scss'
})
export class DashboardTableSkeletonComponent {

}
